module.exports = "/_next/static/images/prefooter-remote-guides@2x_5589ac9d79270a17d23b1f720ad4c925.webp";